import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemReorderEventDetail } from '@ionic/angular';
import { Tables } from '../../../data/database.types';
import { IndexBlockViewModel } from '../../../data/day/index-block-view-model';
import { Topic } from '../../../data/topic/topic';


@Component({
  selector: 'app-day-index-block',
  templateUrl: './day-index-block.component.html',
  styleUrls: ['./day-index-block.component.scss']
})
export class DayIndexBlockComponent implements OnInit {
  @Input() indexBlock?: IndexBlockViewModel;
  @Input() focusedTopicId?: number;

  @Output() topicClick = new EventEmitter<number>();
  @Output() topicReorder = new EventEmitter<Topic[]>();

  constructor() {
  }

  ngOnInit() {
  }

  handleReorder(ev: CustomEvent<ItemReorderEventDetail>) {
    const oldOrder = [...this.indexBlock!.vms.map(x => x.topic)];
    const newOrder = [...ev.detail.complete([...oldOrder]) as Topic[]];

    const updatedTopics: Topic[] = newOrder
      .map((topic, index) => {
        // console.log('mapping', topc)
        return {
          ...topic,
          order_number: oldOrder[index].order_number
        }
      });

    this.topicReorder.emit(updatedTopics);
  }
}
